<button
  type="button"
  class="tw-relative tw-flex lg:tw-hidden tw-h-[41px] tw-w-[41px] tw-shrink-0 tw-items-center tw-justify-center !tw-rounded-lg tw-border tw-border-gray-300 tw-bg-white"
  [attr.aria-label]="'Filter'"
  (click)="onClick()"
  [ngClass]="{'tw-border-gray-800': activeCount() > 0}"
>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_47835_18946)">
    <path d="M0.173552 1.35758L5.25499 8.06061V11.4545L8.74501 14V8.06061L13.8264 1.35758C13.9233 1.23129 13.9822 1.08108 13.9966 0.923843C14.0109 0.766604 13.9801 0.608571 13.9076 0.467515C13.8351 0.326459 13.7238 0.207975 13.5862 0.125384C13.4487 0.0427944 13.2902 -0.000625592 13.1288 6.81074e-06H0.871208C0.709765 -0.000625592 0.551344 0.0427944 0.413757 0.125384C0.27617 0.207975 0.164875 0.326459 0.0923862 0.467515C0.0198978 0.608571 -0.0109091 0.766604 0.00342961 0.923843C0.0177684 1.08108 0.0766841 1.23129 0.173552 1.35758Z" fill="#374151"/>
    </g>
    <defs>
    <clipPath id="clip0_47835_18946">
    <rect width="14" height="14" fill="white"/>
    </clipPath>
    </defs>
  </svg>
  @if (activeCount() > 0) {
    <span
      class="tw-absolute -tw-top-1.5 -tw-end-1.5 tw-flex tw-h-[18px] tw-min-w-[18px] tw-items-center tw-justify-center tw-rounded-full tw-bg-red-500 tw-px-1 tw-text-[11px] tw-font-medium tw-leading-none tw-text-white"
    >
      {{ activeCount() }}
    </span>
  }
</button>
